<template>
  <div class="">
		<div class="login-content">
      <div class="pt20">
        <a class="logo" href="/"><img src="static/images/logo.png" /></a>
      </div>
      <div class="login">
        <div class="">
          <div class="home-prize">
            <div class="font1 ac mt50 fs36 crfff" style="padding: 0 10px;">{{$t('landTips1')}}</div>
            <div class="font1 ac mt10 fs40" style="color:#fb7925">{{$t('landTips2')}}</div>
            <div class="home1 ac">
              <img style="width:80%;margin: 20px auto;" src="../../static/images/land.png" />
            </div>
            <div class="fs27 ac crfff" style="padding: 0 20px;">
              {{$t('landTips3')}}
            </div>
          </div>
          <div class="ac disflex mt50" style="justify-content: center;padding:0 6%">
            <div style="width: 85%;position: relative;" :class="{'active':type=='daily'}" @click="getTypeLogin('daily')">
              <button class="button fw7" style="background:linear-gradient(90deg,#de047f, #fe65bf);width: 100%;">{{$t('Daily')}}</button>
              <div class="free fw7" style="background: #ffcb31;color:#fff;position: absolute;border-radius: 100%;width: 1.1rem;height: 1.1rem;line-height: 1.1rem;text-align: center;font-size: 0.3rem;right: -0.2rem;;top: -0.15rem;"><!-- <img style="width:80%;margin: 20px auto;" src="../../static/images/Free.png" /> -->{{$t('free')}}</div>
            </div>
            <!-- <div style="width: 45%;" :class="{'active':type=='weekly'}" @click="getTypeLogin('weekly')">
              <button style="background:linear-gradient(90deg,#5e96fc, #44ffd0);width: 100%;" class="button fw7">{{$t('Weekly')}}</button>
            </div> -->
          </div>
          <div class="ac otp-b disflex mt100" style="color: #fff;">
            <div class="icon icon2" @click="getType('termsAndCondition')">{{$t('TC')}} <span class="app-en">>></span></div>
            <div class="icon icon2" @click="getType('faq')">{{$t('FAQ')}} <span class="app-en">>></span></div>
          </div>
        </div>
      </div>
		</div>
	</div>
</template>
<script>
import Header from '../components/HeaderTwo'
export default {
    components:{
		Header
    },
    data() {
      return {
        list:[],
        mobile:'',
        password:'',
        isShow:false,
        type:'',
        show401tip: false,
        show400dailytip: false,
        show400weeklytip: false,

      }
    },
	created(){
    if (this.$route.query.msisdn){
      this.mobile = this.$route.query.msisdn
    }
    if(localStorage.getItem('lang')) this.isEN = localStorage.getItem('lang')
	},
    methods: {
      getType(type){
          this.$router.push({path:type});
      },
		back(){
			this.$router.go(-1);
		},
    tips2Modal(){
      this.$refs.saveDialog2.closeMask();
    },
    getTypeLogin(type){
      this.type = type
      this.isShow = false
      this.goLogin()
    },
    goLogin(){
      let that = this
      var channelId  = this.$route.query.channelId
      var tracker  = this.$route.query.tracker
      var code  = this.$route.query.code
      if(that.mobile==''){
        that.$router.push({path:'/login',query: {type:that.type,channelId:channelId,tracker:tracker,code:code}})
      }else{
        that.$parent.loadModal(true);
        var data = {mobile: that.mobile, password: this.passwd,type:that.type,channelId:channelId,tracker:tracker,code:code}
        that.$api.post('/api/user/sub',data,r =>{
          that.$parent.loadModal(false);
          if (r.code == 1){
            that.$parent.returnCode(r,function(){
              localStorage.setItem('token',r.data.userinfo.token)
              localStorage.setItem('mobile',r.data.userinfo.mobile)
              that.$router.push('/');
            });
          }else{
            that.$utils.alertText(r.msg,100, 3000);
          }

        })
      }
    }
	}
}
</script>
<style scoped>
  .drop-down-content{z-index:9;background:none;}
  .mt100{margin-top:100px;}
  .otp-b{justify-content: space-evenly;}
</style>



// WEBPACK FOOTER //
// src/page/landNew.vue